

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { CompanyStatutoryHolidaySetup } from "../../components/CompanyStatutoryHolidaySetup";


export const CompanyStatutoryHolidayPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Company Statutory Holiday Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Statutory Holiday", navigateTo: "/statutory-holiday" }
      ]}
      mainContents={<CompanyStatutoryHolidaySetup />}
    />
  );
};
